/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectNested,
    ReadOnlyMonitoredObjectNestedFromJSON,
    ReadOnlyMonitoredObjectNestedFromJSONTyped,
    ReadOnlyMonitoredObjectNestedToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20032
 */
export interface InlineResponse20032 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20032
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20032
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20032
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectNested>}
     * @memberof InlineResponse20032
     */
    results: Array<ReadOnlyMonitoredObjectNested>;
}

export function InlineResponse20032FromJSON(json: any): InlineResponse20032 {
    return InlineResponse20032FromJSONTyped(json, false);
}

export function InlineResponse20032FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20032 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectNestedFromJSON)),
    };
}

export function InlineResponse20032ToJSON(value?: InlineResponse20032 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectNestedToJSON)),
    };
}


